<template>
  <div id="app">
	  <router-view></router-view>
    
  </div>
</template>
<strong></strong>
<script>


export default {
  
  
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  height: 100%;
}


</style>
